// ** React Imports
import { Link } from "react-router-dom";

// ** Reactstrap Imports
import { Button } from "reactstrap";

// ** Custom Hooks
import { useSkin } from "@hooks/useSkin";

// ** Illustrations Imports
import illustrationsLight from "@src/assets/images/pages/error.svg";
import illustrationsDark from "@src/assets/images/pages/error-dark.svg";
import logo from "@src/assets/images/logo/assistive-logo.svg";

// ** Styles
import "@styles/base/pages/page-misc.scss";

const Unavailable = () => {
  // ** Hooks
  const { skin } = useSkin();

  const source = skin === "dark" ? illustrationsDark : illustrationsLight;

  return (
    <div className="misc-wrapper">
      <a className="brand-logo" href="/">
        <img src={logo as unknown as string} alt="Logo assistive"></img>
      </a>
      <div className="misc-inner p-2 p-sm-3">
        <div className="w-100 text-center">
          <h2 className="mb-1">Indisponível 🕵🏻‍♀️</h2>
          <p className="mb-2">
            Oops! 😖 tivemos um problema inesperado no servidor.
          </p>
          <p className="mb-2">
            Tente de novo mais tarde.
          </p>
          <Button
            tag={Link}
            to="/"
            color="primary"
            className="btn-sm-block mb-2"
          >
            Voltar pra home
          </Button>
          <img className="img-fluid" src={source as unknown as string} alt="Not authorized page" />
        </div>
      </div>
    </div>
  );
};
export default Unavailable;
